import { Text } from "@chakra-ui/react";

function PageIndicator({ currentPage, totalPages }) {
  if (totalPages <= 1) return null;

  return (
    <Text
      fontSize="xl"
      fontWeight={600}
      color="gray.600"
      textAlign="center"
      py={2}
      flexShrink={0}
    >
      Page {currentPage + 1} of {totalPages}
    </Text>
  );
}

export default PageIndicator;
